import React, { useEffect } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import BackroomNeeded from "./inventory_reports/BackroomNeeded";

export default function ReportsInventoryReportViewer(props) {

  const { controller = "", setController = () => { }, route = "", signal = {}, state = {} } = props;

  const {variant = ""} = state;



  useEffect(() => {

    let actions = [
      { key: KBD.ESCAPE, action: (e) => { props.switchView("reports") } },

    ];


    const cleanup = listen(controller, route, actions, false, [KBD.ENTER]);
    return cleanup;
  }, []);


  switch(variant){
    case "00000000-0000-0000-0000-000000000002":
      return <BackroomNeeded state={state} controller={controller} route={route} callback={() => {}} signal={signal} />
  }

  return (
    <>
       <div className="controller component-layout">
        stuff
        <pre>{JSON.stringify(state, null, 2)}</pre>
       </div>
    </>
  )
}